import React from 'react';

import {
  RadarServices,
  Radar_MaterialType,
  Radar_ModelMaterial_Status,
} from '@quan/proto-api-client';

import { persistUserStore } from '@/stores';
import { reaction } from 'mobx';
import userStore from '@/stores/user';
import { LoadScript, useDebounce } from '@planjs/react-utils';
import { eventsPush } from '@quan/cdp-sdk';

import { config, isWeiXin, WX_JS_CONFIG } from '@/services/wx_services';

import InvalidPage from './components/invalid-page';
import queryString from 'query-string';
import qs from 'querystring';
import WxLogin from '@/components/wx_login';

import { QliconiconFangxiangXia1Filled } from '@quan/icon-font';
import moment from 'moment';
import appModuleStyle from '../../App.module.scss';
import '@/styles//braft-editor-reset.css';
import styles from './index.module.less';

enum CdpEventType {
  Click = 'material.click',
  ViewDuration = 'material.view_duration',
  CompletionRate = 'material.completion_rate',
  Close = 'material.close_page',
  share = 'material.share',
}

type CdpType = {
  event_name: CdpEventType;
  entity_type?: string;
  target_entity_type?: string;
  target_entity_id: string;
  properties?: {
    material_type?: number;
    href?: string;
    title?: string;
    view_duration?: number;
    completion_rate?: number;
    share_from?: number;
    share_from_name?: string;
    view_duration_step?: number;
  };
};

const Radar: React.FC = () => {
  const { info, debug } = React.useMemo(
    () =>
      ({
        ...queryString.parse(window.location.search),
      } as {
        info?: string;
        debug?: string;
      }),
    [],
  );

  const { id, type, share_from, share_from_name } = React.useMemo(() => {
    let search = '';

    try {
      search = atob(decodeURIComponent(info ?? ''));
    } catch (error) {
      search = '';
    }

    return {
      ...queryString.parse(search),
    } as {
      id: string;
      type?: string;
      share_from?: string;
      share_from_name?: string;
    };
  }, [info]);

  const Link = React.useCallback((search: { [key: string]: any }) => {
    return `${window.location.origin}/app/mlp/radar?info=${encodeURIComponent(
      btoa(`${qs.stringify(search)}`),
    )}`;
  }, []);

  const ViewDurationStep = 5;

  const [isInit, setIsInit] = React.useState(false);
  const [isInvalid, setIsInvalid] = React.useState(false);
  const [openDisclaimer, setOpenDisclaimer] = React.useState(false);
  const [contentHeight, setContentHeight] = React.useState(0);
  const [viewDuration, setViewDuration] = React.useState(0);

  const [material, setMaterial] = React.useState<radar.ModelMaterial | undefined>(undefined);
  const [rate, setRate] = React.useState(0);
  const [scrollHeight, setScrollHeight] = React.useState(0);
  const debouncedRate = useDebounce(rate, 3000);
  const [wxConfig, setWxConfig] = React.useState<radar.ModelConfig | undefined>(undefined);
  const [wxInfo, setWxInfo] = React.useState<{ uid?: string; name?: string }>({});

  React.useEffect(() => {
    setInterval(() => {
      setViewDuration((viewDuration) => viewDuration + 1);
    }, 1000);
  }, []);

  const cdp = React.useCallback(
    async ({
      event_name,
      entity_type = 'wechat_user_id',
      target_entity_id,
      target_entity_type = 'radar_material',
      properties,
    }: CdpType) => {
      if (!wxInfo.uid || wxInfo.uid === '0') return;

      console.log({
        event_name,
        entity_type,
        entity_id: wxInfo.uid, // 微信id
        target_entity_type,
        target_entity_id,
        properties: {
          ...properties,
        },
        cur_time: moment().unix(),
      });

      eventsPush.track({
        event_name,
        entity_type,
        entity_id: wxInfo.uid, // 微信id
        target_entity_type,
        target_entity_id,
        properties: {
          ...properties,
        },
        cur_time: moment().unix(),
      });
    },
    [wxInfo.uid],
  );

  const initCdp = ({ corp_id }: { corp_id: string }) => {
    const api_host = window.location.host.includes('www.aquanliang.com')
      ? 'api.aquanliang.com'
      : 'api-dev.aquanliang.com';
    eventsPush.init({
      server_url: `https://${api_host}/gateway/evententry/collect.gif?token=1d62518c6c691c57934808077fa5d563`,
      corp_id,
    });
    setIsInit(true);
  };

  React.useEffect(() => {
    if (!isInit) return;
    // 定时传view_duration，5s
    if (viewDuration && viewDuration % ViewDurationStep === 0) {
      cdp({
        event_name: CdpEventType.ViewDuration,
        target_entity_id: material?.id!,
        properties: {
          material_type: material?.material_type,
          title: material?.title,
          href:
            material?.material_type === Radar_MaterialType.MaterialTypeWebPage
              ? material?.content
              : Link({ id, type: 'preview' }),
          view_duration: viewDuration,
          view_duration_step: ViewDurationStep,
        },
      });
    }
  }, [
    Link,
    cdp,
    id,
    isInit,
    material?.id,
    material?.material_type,
    material?.content,
    material?.title,
    viewDuration,
  ]);

  const RadarRef = React.useCallback((node) => {
    if (node !== null) {
      setContentHeight(Math.floor(node.getBoundingClientRect().height));
    }
  }, []);

  React.useEffect(() => {
    if (isInit && material && userStore.loginResp) {
      console.log('次数+1');
      cdp({
        event_name: CdpEventType.Click,
        target_entity_id: material?.id!,
        properties: {
          href:
            material?.material_type === Radar_MaterialType.MaterialTypeWebPage
              ? material?.content
              : Link({ id, type: 'preview' }),
          material_type: material.material_type,
          title: material?.title,
          ...(share_from ? { share_from: Number(share_from) } : {}),
          ...(share_from_name ? { share_from_name } : {}),
        },
      }).then(() => {
        setTimeout(() => {
          if (
            material?.material_type === Radar_MaterialType.MaterialTypeWebPage &&
            material?.content
          ) {
            console.log('跳转 1');
            if (!debug) window.location.replace(material?.content!);
          }
        }, 1000);
      });

      if (material?.material_type === Radar_MaterialType.MaterialTypeWebPage) return;
      // 内容不足一页的情况
      if (contentHeight <= window.innerHeight) {
        setRate(100);
      } else {
        const rate = Math.floor((window.innerHeight / contentHeight) * 100);

        setRate(rate >= 100 ? 100 : rate);
      }
    }
  }, [isInit, contentHeight, material, cdp, share_from, Link, id, share_from_name, debug]);

  const initData = React.useCallback(
    (need_init_sdk = true) => {
      if (!id) return;
      RadarServices.GetMaterial4Public({ id })
        .then(({ material, config }) => {
          setMaterial(material);
          setWxConfig(config);

          document.title = material?.title ?? '加载中';

          if (material?.status === Radar_ModelMaterial_Status.StatusDisable) {
            setIsInvalid(true);
            return;
          }
          if (need_init_sdk) {
            initCdp({ corp_id: String(material?.corp_id!) });
          } else if (
            material?.material_type === Radar_MaterialType.MaterialTypeWebPage &&
            material?.content
          ) {
            console.log('跳转 2');
            if (!debug) window.location.replace(material?.content!);
          }
        })
        .catch((err) => {
          setIsInvalid(true);
        });
    },
    [debug, id],
  );

  React.useEffect(() => {
    if (type === 'preview') {
      initData(false);
      return;
    }
    initData();
  }, [initData, type]);

  React.useEffect(() => {
    if (!debouncedRate || !isInit) return;
    cdp({
      event_name: CdpEventType.CompletionRate,
      target_entity_id: material?.id!,
      properties: {
        href:
          material?.material_type === Radar_MaterialType.MaterialTypeWebPage
            ? material?.content
            : Link({ id, type: 'preview' }),
        material_type: material?.material_type,
        title: material?.title,
        completion_rate: debouncedRate,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedRate]);

  const onScroll = React.useCallback(() => {
    if (!contentHeight) return;

    setScrollHeight(Math.floor(((window.innerHeight + window.scrollY) / contentHeight) * 100));
  }, [contentHeight]);

  React.useEffect(() => {
    if (scrollHeight > rate) {
      setRate(scrollHeight >= 100 ? 100 : scrollHeight);
    }
  }, [rate, scrollHeight]);

  React.useEffect(() => {
    window.addEventListener('scroll', () => onScroll());
    return window.removeEventListener('scroll', () => onScroll);
  }, [onScroll]);

  window.onunload = () => {
    if (material?.material_type === Radar_MaterialType.MaterialTypeWebPage) return;
    cdp({
      event_name: CdpEventType.Close,
      target_entity_id: material?.id!,
      properties: {
        href:
          material?.material_type === Radar_MaterialType.MaterialTypeWebPage
            ? material?.content
            : Link({ id, type: 'preview' }),
        material_type: material?.material_type,
        title: material?.title,
        completion_rate: rate,
        view_duration: viewDuration,
        ...(share_from ? { share_from: Number(share_from) } : {}),
        ...(share_from_name ? { share_from_name } : {}),
      },
    });
  };

  React.useEffect(() => {
    if (type === 'preview') return;
    persistUserStore.then((userStore) => {
      if (userStore.loginResp) {
        console.log(userStore.loginResp);
        const wx_info = localStorage.getItem('wx_info');
        console.log('wx_info', wx_info);
        setWxInfo(JSON.parse(wx_info ?? '{}'));
      }
      reaction(
        () => userStore.loginResp,
        (res) => {
          if (res) {
            console.log(res);
            console.log('wx_info', userStore.wx_info);
            localStorage.setItem('wx_info', JSON.stringify(userStore.wx_info));
            setWxInfo(userStore.wx_info);
            // 登录成功
          }
        },
      );
    });
  }, [type]);

  return (
    <>
      {/* <WxLogin appid="wx8f580b459d3e058b"></WxLogin> */}
      {isInvalid ? (
        <InvalidPage />
      ) : type === 'preview' ? (
        <>
          {[Radar_MaterialType.MaterialTypeArticle].includes(
            material?.material_type ?? Radar_MaterialType.MaterialTypeNil,
          ) ? (
            <div ref={RadarRef}>
              <div className={styles['article']}>
                <div className={styles['article-title']}>{material?.title}</div>
                {material?.source && (
                  <div className={styles['article-source']}>{material?.source}</div>
                )}

                <div className={styles['article-content']}>
                  <div dangerouslySetInnerHTML={{ __html: material?.content ?? '' }}></div>
                </div>

                <div
                  className={styles['disclaimer']}
                  onClick={() => setOpenDisclaimer((state) => !state)}
                >
                  免责声明
                  <QliconiconFangxiangXia1Filled className={styles['disclaimer-icon']} />
                </div>
                {openDisclaimer ? (
                  <div className={styles['disclaimer-info']}>
                    素材为用户自主上传，版权为作者所有，如发现版权或侵权问题，请联系我们
                    ql@quanliang.com 进行处理
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
        </>
      ) : (
        <>
          {wxConfig?.wx_authorizer_appid ? (
            <>
              {isWeiXin() && userStore.loginResp && (
                <LoadScript
                  url={WX_JS_CONFIG}
                  onLoad={() => {
                    config({
                      appId: wxConfig?.wx_authorizer_appid!,
                      jsApiList: ['onMenuShareAppMessage'],
                      readyFn: () => {
                        wx.onMenuShareAppMessage({
                          title: material?.share_config.title ?? '',
                          desc: material?.share_config.desc ?? '',
                          link: Link({ id, share_from: wxInfo.uid, share_from_name: wxInfo.name }),
                          imgUrl: material?.share_config.icon_url ?? '',
                          success: () => {
                            cdp({
                              event_name: CdpEventType.share,
                              target_entity_id: material?.id!,
                              properties: {
                                href:
                                  material?.material_type === Radar_MaterialType.MaterialTypeWebPage
                                    ? material?.content
                                    : Link({ id, type: 'preview' }),
                                material_type: material?.material_type,
                                title: material?.title,
                              },
                            });
                          },
                        });
                      },
                    });
                  }}
                />
              )}
              {isWeiXin() && userStore?.loginResp?.is_snapshotuser === 1 && (
                <div className={appModuleStyle.is_snapshotuser_tips}>
                  <div className={appModuleStyle.card}>
                    <img
                      className={appModuleStyle.bg}
                      src="https://pkg.aquanliang.com/assets/wx-login-tips-bg.png"
                      alt=""
                    />
                    <div className={appModuleStyle.text}>
                      扫码前请先点击
                      <br />
                      “使用完整服务”完成授权
                    </div>
                  </div>
                </div>
              )}
              <WxLogin appid={wxConfig?.wx_authorizer_appid}>
                {[Radar_MaterialType.MaterialTypeArticle].includes(
                  material?.material_type ?? Radar_MaterialType.MaterialTypeNil,
                ) ? (
                  <div ref={RadarRef}>
                    <div className={styles['article']}>
                      <div className={styles['article-title']}>{material?.title}</div>
                      {material?.source && (
                        <div className={styles['article-source']}>{material?.source}</div>
                      )}

                      <div className={styles['article-content']}>
                        <div dangerouslySetInnerHTML={{ __html: material?.content ?? '' }}></div>
                      </div>

                      <div
                        className={styles['disclaimer']}
                        onClick={() => setOpenDisclaimer((state) => !state)}
                      >
                        免责声明
                        <QliconiconFangxiangXia1Filled className={styles['disclaimer-icon']} />
                      </div>
                      {openDisclaimer ? (
                        <div className={styles['disclaimer-info']}>
                          素材为用户自主上传，版权为作者所有，如发现版权或侵权问题，请联系我们
                          ql@quanliang.com 进行处理
                        </div>
                      ) : null}
                    </div>
                  </div>
                ) : null}
              </WxLogin>
            </>
          ) : null}
        </>
      )}
    </>
  );
};

export default React.memo(Radar);
